<ng-container *ngFor="let postAdress of addresses">
	<div *ngIf="postAdress.room">{{postAdress.room}}</div>
	<div *ngIf="postAdress.floor">{{postAdress.floor}}</div>
	<div *ngIf="postAdress.building">{{postAdress.building}}</div>
	<div *ngIf="postAdress.street">{{postAdress.street}}</div>
	<div *ngIf="postAdress.postcode && postAdress.city">{{postAdress.postcode}} {{postAdress.city}}</div>
	<div *ngIf="postAdress.country">{{postAdress.country}}</div>
    <br />
</ng-container>
